import React from 'react';
import Form from 'react-bootstrap/Form';

type TeachWithUsTabId = 'Introduction' | 'Benefits' | 'FAQs' | 'CoursesWanted' | 'Application';

interface TeachWithUsTab {
    id: TeachWithUsTabId;
    name: string;
    url: string;
}

interface TeachWithUsTabLinkMetadata {
    elementId: string;
    label: string;
}

interface TeachWithUsApplicationFormModel {
    submitPath: string;
}

const tabLinkMetadata: Record<TeachWithUsTabId, TeachWithUsTabLinkMetadata> = {
    Introduction: {
        elementId: 'hlkTeachIntro',
        label: 'INTRODUCTION',
    },
    Benefits: {
        elementId: 'hlkTeachBenefits',
        label: 'BENEFITS',
    },
    FAQs: {
        elementId: 'hlkTeachFAQs',
        label: 'FAQS',
    },
    CoursesWanted: {
        elementId: 'hlkTeachCoursesWanted',
        label: 'COURSES WANTED',
    },
    Application: {
        elementId: 'hlkTeachApply',
        label: 'APPLY',
    },
};

interface TeachWithUsProps {
    currentTab: TeachWithUsTabId;
    isSubmitted: boolean;
    applicationFormModel: TeachWithUsApplicationFormModel;
    tabs: TeachWithUsTab[];
}

interface Question {
    id: string;
    text: string;
    note: React.ReactNode;
}

const benefits = ['Credibility', 'Satisfaction', 'Support', 'Efficiency', 'Scalability', 'Marketing', 'Compensation'];
const teachImagePath = '/assets/image/teach.jpg';
const applyButtonImagePath = '/assets/image/btn_teach.png';
const submitButtonBackgroundPath = '/assets/image/btn_submit_bg.jpg';
const submitButtonHoverBackgroundPath = '/assets/image/btn_submit_hover_bg.jpg';

const legacyTeachWithUsStyles = `
.teach-with-us-legacy,
.teach-with-us-legacy div,
.teach-with-us-legacy a,
.teach-with-us-legacy p,
.teach-with-us-legacy h1,
.teach-with-us-legacy h2,
.teach-with-us-legacy h3,
.teach-with-us-legacy span,
.teach-with-us-legacy ul,
.teach-with-us-legacy ol,
.teach-with-us-legacy li,
.teach-with-us-legacy label {
    font-family: 'Open Sans', Verdana, Geneva, sans-serif;
    font-weight: 400;
    font-size: 14px !important;
}

.teach-with-us-legacy {
    background: #fff;
    color: #1c1c1c;
    padding: 20px 0 35px;
}

.teach-with-us-legacy .rowInner {
    width: 87%;
    max-width: 1680px;
    margin: 0 auto;
    padding: 0;
}

.teach-with-us-legacy .leftCol {
    float: left;
    width: 68%;
}

.teach-with-us-legacy .rightCol {
    float: right;
    width: 29%;
    margin-bottom: 11px;
}

.teach-with-us-legacy .section {
    margin-bottom: 20px;
}

.teach-with-us-legacy h1 {
    margin: 0;
    padding-bottom: 0;
    border: 0;
    color: #333;
    font-size: 32px !important;
    font-weight: 300;
    line-height: 1.2;
    padding-top: 16px;
}

.teach-with-us-legacy .rightCol h1 {
    margin: 1px 0 15px;
    color: #005b86;
    font-size: 24px !important;
    font-weight: 400;
    line-height: 1.1;
}

.teach-with-us-legacy h2 {
    margin: 24px 0 10px;
    color: #2c9ed5;
    font-size: 22px !important;
    font-weight: 500;
    line-height: 1.2;
}

.teach-with-us-legacy h3 {
    margin: 18px 0 6px;
    color: #333;
    font-size: 18px !important;
    line-height: 1.25;
}

.teach-with-us-legacy p {
    margin: 8px 0;
    font-size: 13px !important;
    line-height: 18px;
}

.teach-with-us-legacy a,
.teach-with-us-legacy a:visited,
.teach-with-us-legacy a:active {
    color: #0066c0;
    text-decoration: none;
}

.teach-with-us-legacy a:hover {
    color: #333;
    text-decoration: none;
}

.teach-with-us-legacy .subNav {
    clear: both;
    float: none;
    width: 100%;
    text-align: left;
}

.teach-with-us-legacy .subNav ul {
    margin: 10px 0 0;
    padding: 0;
    list-style: none;
}

.teach-with-us-legacy .subNav li {
    float: left;
    margin: 0 15px 25px 0;
}

.teach-with-us-legacy .subNav li a {
    display: block;
    padding: 5px 11px;
    border-radius: 5px;
    font-size: 12px !important;
    line-height: 1.1;
    text-transform: uppercase;
}

.teach-with-us-legacy #hlkTeachIntro,
.teach-with-us-legacy #hlkTeachIntro:visited,
.teach-with-us-legacy #hlkTeachIntro:active,
.teach-with-us-legacy #hlkTeachBenefits,
.teach-with-us-legacy #hlkTeachBenefits:visited,
.teach-with-us-legacy #hlkTeachBenefits:active,
.teach-with-us-legacy #hlkTeachFAQs,
.teach-with-us-legacy #hlkTeachFAQs:visited,
.teach-with-us-legacy #hlkTeachFAQs:active,
.teach-with-us-legacy #hlkTeachCoursesWanted,
.teach-with-us-legacy #hlkTeachCoursesWanted:visited,
.teach-with-us-legacy #hlkTeachCoursesWanted:active,
.teach-with-us-legacy #hlkTeachApply,
.teach-with-us-legacy #hlkTeachApply:visited,
.teach-with-us-legacy #hlkTeachApply:active {
    display: block;
    padding: 5px 11px;
    border: 0;
    border-radius: 5px;
    background: transparent;
    color: #0066c0;
    font-family: 'Open Sans', Verdana, Geneva, sans-serif !important;
    font-size: 12px !important;
    font-weight: 400;
    line-height: 1.1;
    text-decoration: none;
    text-transform: uppercase;
}

.teach-with-us-legacy .subNav li a.current {
    background: #4078aa;
    color: #fff;
}

.teach-with-us-legacy .subNav li a:hover {
    background: #efefef;
    color: #333;
}

.teach-with-us-legacy .subNav li a.current:hover {
    background: #4078aa;
    color: #fff;
}

.teach-with-us-legacy #hlkTeachIntro.current,
.teach-with-us-legacy #hlkTeachBenefits.current,
.teach-with-us-legacy #hlkTeachFAQs.current,
.teach-with-us-legacy #hlkTeachCoursesWanted.current,
.teach-with-us-legacy #hlkTeachApply.current {
    border-radius: 5px;
    background: #4078aa;
    color: #fff;
    font-size: 12px !important;
    font-weight: 400;
}

.teach-with-us-legacy #hlkTeachIntro:hover,
.teach-with-us-legacy #hlkTeachBenefits:hover,
.teach-with-us-legacy #hlkTeachFAQs:hover,
.teach-with-us-legacy #hlkTeachCoursesWanted:hover,
.teach-with-us-legacy #hlkTeachApply:hover {
    border-radius: 5px;
    background: #efefef;
    color: #333;
    font-size: 12px !important;
    font-weight: 400;
    text-decoration: none;
}

.teach-with-us-legacy #hlkTeachIntro.current:hover,
.teach-with-us-legacy #hlkTeachBenefits.current:hover,
.teach-with-us-legacy #hlkTeachFAQs.current:hover,
.teach-with-us-legacy #hlkTeachCoursesWanted.current:hover,
.teach-with-us-legacy #hlkTeachApply.current:hover {
    background: #4078aa;
    color: #fff;
}

.teach-with-us-legacy .intro {
    margin: 0 0 28px;
    padding-bottom: 25px;
    border-bottom: 1px solid #efefef;
    color: #005187;
    font-size: 22px;
    line-height: 1.45;
}

.teach-with-us-legacy img.teachPic {
    float: right;
    width: 300px;
    margin: 0 0 22px 34px;
    border: 1px solid #ccc;
    border-radius: 5px;
}

.teach-with-us-legacy .benefits {
    padding: 5px;
}

.teach-with-us-legacy .benefits ul {
    margin: 0;
    padding: 0;
    list-style: none;
    column-count: 2;
    column-gap: 42px;
}

.teach-with-us-legacy .benefits li {
    margin: 0 0 12px;
    font-size: 20px;
    line-height: 1.2;
    break-inside: avoid;
}

.teach-with-us-legacy .applyBtn {
    padding: 0 0 30px;
    text-align: center;
}

.teach-with-us-legacy .applyBtn img {
    width: 85%;
    max-width: 365px;
    height: auto;
    padding-top: 0;
}

.teach-with-us-legacy .important h1 {
    color: #005b86;
}

.teach-with-us-legacy .bold {
    font-weight: bold;
}

.teach-with-us-legacy .red {
    color: #c00;
}

.teach-with-us-legacy .ital {
    font-style: italic;
}

.teach-with-us-legacy .validation-summary {
    margin: 8px 0 16px 20px;
    padding-left: 20px;
}

.teach-with-us-legacy ol.faqs {
    margin-left: 20px;
    padding-left: 20px;
}

.teach-with-us-legacy ol.faqs li {
    margin-bottom: 20px;
    padding-bottom: 10px;
    font-weight: bold;
}

.teach-with-us-legacy ol.faqs li .question {
    font-weight: bold;
    color: #1a5d7f !important;
}

.teach-with-us-legacy ol.faqs li .answer {
    margin-top: 10px;
}

.teach-with-us-legacy ol.faqs li .answer .note {
    color: #777;
    font-size: 11px !important;
    font-style: italic;
}

.teach-with-us-legacy ol.faqs li .answer .note a {
    font-size: inherit !important;
    font-style: inherit;
    font-weight: inherit;
    line-height: inherit;
}

.teach-with-us-legacy ol.faqs label {
    margin-right: 20px;
    font-weight: 700;
}

.teach-with-us-legacy ol.faqs .formField {
    width: 400px;
    max-width: 100%;
}

.teach-with-us-legacy .form-check-inline {
    display: inline-block;
}

.teach-with-us-legacy .form-check-input.is-valid ~ .form-check-label,
.teach-with-us-legacy .form-check-input.is-invalid ~ .form-check-label,
.teach-with-us-legacy .was-validated .form-check-input:valid ~ .form-check-label,
.teach-with-us-legacy .was-validated .form-check-input:invalid ~ .form-check-label {
    color: inherit !important;
}

.teach-with-us-legacy .cms ul {
    margin: 10px 20px 20px;
}

.teach-with-us-legacy .cms li {
    margin-bottom: 5px;
    font-size: 18px;
}

.teach-with-us-legacy .clearfix {
    clear: both;
}

.teach-with-us-legacy .form-control {
    max-width: 100%;
}

.teach-with-us-legacy .form-control.is-valid,
.teach-with-us-legacy .form-control.is-invalid,
.teach-with-us-legacy .was-validated .form-control:valid,
.teach-with-us-legacy .was-validated .form-control:invalid {
    border-color: #ced4da;
    background-image: none;
    box-shadow: none;
}

.teach-with-us-legacy .invalid-feedback {
    display: none !important;
}

.teach-with-us-legacy p.submit {
    padding-left: 0;
    text-align: center;
}

.teach-with-us-legacy .submitButton {
    width: auto !important;
    padding: 5px 10px;
    border: 1px solid #2c5a92;
    border-radius: 5px;
    background: url('${submitButtonBackgroundPath}');
    color: #2c5a92;
    font-weight: bold;
}

.teach-with-us-legacy .submitButton:hover {
    background: url('${submitButtonHoverBackgroundPath}');
    cursor: pointer;
}

@media screen and (max-width: 980px) {
    .teach-with-us-legacy .rowInner {
        width: calc(100% - 40px);
    }

    .teach-with-us-legacy .leftCol,
    .teach-with-us-legacy .rightCol {
        float: none;
        width: 100%;
    }

    .teach-with-us-legacy .rightCol {
        margin-top: 24px;
    }

    .teach-with-us-legacy .applyBtn {
        text-align: center;
    }

    .teach-with-us-legacy .applyBtn img {
        max-width: 300px;
    }

}

@media screen and (min-width: 641px) {
    .teach-with-us-legacy ol.faqs .formField {
        width: 100%;
    }
}

@media screen and (max-width: 640px) {
    .teach-with-us-legacy {
        padding-top: 16px;
    }

    .teach-with-us-legacy .rowInner {
        width: calc(100% - 24px);
    }

    .teach-with-us-legacy h1 {
        font-size: 36px;
    }

    .teach-with-us-legacy .rightCol h1,
    .teach-with-us-legacy h2 {
        font-size: 28px;
    }

    .teach-with-us-legacy p,
    .teach-with-us-legacy .benefits li {
        font-size: 18px;
    }

    .teach-with-us-legacy .intro {
        font-size: 19px;
    }

    .teach-with-us-legacy img.teachPic {
        float: none;
        width: 75%;
        margin: 0 10% 20px;
    }

    .teach-with-us-legacy .subNav li {
        margin-right: 8px;
        margin-bottom: 12px;
    }

    .teach-with-us-legacy .subNav li a {
        padding: 7px 10px;
        font-size: 14px;
    }

    .teach-with-us-legacy .benefits ul {
        column-count: 1;
    }

    .teach-with-us-legacy p.submit {
        padding-left: 40px;
        text-align: left;
    }
}

@media screen and (min-width: 480px) {
    .teach-with-us-legacy img.teachPic {
        margin-left: 20px;
        margin-right: 0;
        float: right;
        width: 200px;
    }
}
`;

const questions: Question[] = [
    {
        id: 'Question1',
        text: 'Will our relationship with you be free of any potential conflicts of interest?',
        note: 'We cannot accept your application if you work for a company that competes for students, either directly or indirectly, with any of the schools in the Education To Go network.',
    },
    {
        id: 'Question2',
        text: 'Do you have a college degree?',
        note: 'The Education To Go network is primarily made up of colleges and universities. Our partners will want reassurance that you believe strongly in the value of higher education. As such, we prefer to hear from applicants who both made and kept the commitment to earn a college degree.',
    },
    {
        id: 'Question3',
        text: 'Do you have excellent written communication skills?',
        note: 'Most communication on the Internet is done in writing. Our students expect you to write clearly and correctly. You must be able to provide our students with written course materials of the highest quality.',
    },
    {
        id: 'Question4',
        text: 'Are you willing to enter into a confidentiality agreement with us?',
        note: 'We have served more students for a longer period of time than anybody in the online education industry. We have developed time-tested and wildly successful online teaching methodologies that many in our industry have not yet discovered. Before we provide you with any training, we will ask you to sign a binding confidentiality agreement. The document provides us with your written guarantee that you will not disclose our secrets to anyone else or use those secrets to compete unfairly against us.',
    },
    {
        id: 'Question5',
        text: 'Will you write to our specifications?',
        note: "Your success with any publisher depends on your ability to adapt to that publisher's style. We're not willing to stray from our winning format. We're looking for writers who can develop courses that are consistent with all of our other courses in tone, style, and length.",
    },
    {
        id: 'Question6',
        text: 'Can you write a course so complete that it does not require a textbook?',
        note: 'Your course should be so complete, well-researched, and well-written that your students will not require a textbook or other peripheral materials. When your course is fully written, your students should be able to print your lessons to use as a comprehensive reference guide to the subject matter you teach. Do you know your material well enough to write a course that does not require any outside materials?',
    },
    {
        id: 'Question7',
        text: 'Do you have time to write a course?',
        note: 'A typical Education To Go course consists of 120 single-spaced, 8.5" x 11" pages of text. Most of our instructors are able to produce roughly one page an hour. At that rate, it would take you 120 hours to develop an entire course. We\'re looking for instructors who can complete a course for us in three months or less. Be honest: can you spend two or more hours a day writing a course to completion?',
    },
    {
        id: 'Question8',
        text: 'Can you meet deadlines?',
        note: 'Once you set a deadline for delivery of your course, we will hold you to that date. We like to see instructors who are organized and considerate of others.',
    },
    {
        id: 'Question9',
        text: 'Are you willing to improve your course after it has been written?',
        note: 'We will be going over each and every document you submit to us very carefully, and we may return some of your lessons to you with corrections and suggestions. We like to work with instructors who see the lessons they write as unfinished products, and who rely on our informed opinions to help them build a better course.',
    },
    {
        id: 'Question10',
        text: 'Do you have time to facilitate your course?',
        note: 'All of our courses are instructor-moderated. This means that we will require you to spend at least two hours each weekday interacting with your students or improving your course material. We have found a direct correlation between the time an instructor spends in his or her classroom and the level of student satisfaction with the course. This satisfaction usually translates into good word of mouth and soaring enrollments. However, you need to ask yourself: can you spare ten hours a week to support your students?',
    },
    {
        id: 'Question11',
        text: 'Do you have excellent people skills?',
        note: 'Working with students over the Internet can be both invigorating and frustrating. How you respond when a student frustrates you will determine your success with us. We look for instructors who love to help others. We look for instructors who are humble, eager to assist those in need, and respectful of the thoughts and beliefs of others.',
    },
    {
        id: 'Question12',
        text: 'Is your course unique and well-suited to our demographic?',
        note: (
            <>
                We like to see fresh ideas. Obviously, we cannot develop a title that is already in our catalog. So
                please do a little research before you submit your application. Take a look at our{' '}
                <a href="/TeachWithUs.aspx?tab=CoursesWanted" target="research">
                    courses wanted
                </a>{' '}
                page to get a good idea of the types of courses we&apos;re interested in developing at this time. Then,
                explore our{' '}
                <a href="/search" target="research">
                    {' '}
                    online course catalog
                </a>{' '}
                to get a good feel for what we do offer and to make sure you aren&apos;t proposing to develop and teach
                a course we already have.
                <br />
                <br />
                And finally, please make sure that you are submitting a course that will appeal to working adults, most
                of whom are between the ages of 25 and 75. Although we work with major colleges and universities, it is
                important to note that we do not target college students. Instead, we serve their parents and
                grandparents.
            </>
        ),
    },
];

const getTabUrl = (tabs: TeachWithUsTab[], id: TeachWithUsTabId): string => {
    return tabs.find((tab) => tab.id === id)?.url || '#';
};

const getFormValue = (formData: FormData, name: string): string => (formData.get(name)?.toString() || '').trim();

const requiredApplicationFields: Array<[string, string]> = [
    ['course_title', 'Title Required.'],
    ['course_description', 'Description Required.'],
    ['target_audience', 'Target Audience Required.'],
    ['email', 'Email Required.'],
    ['first_name', 'First Name Required.'],
    ['last_name', 'Last Name Required.'],
    ['phone', 'Day Phone Required.'],
];

const getTeachWithUsApplicationValidationMessages = (form: HTMLFormElement, formData: FormData): string[] => {
    const messages: string[] = [];
    const title = getFormValue(formData, 'course_title');
    const description = getFormValue(formData, 'course_description');
    const email = getFormValue(formData, 'email');
    const emailInput = form.elements.namedItem('email') as HTMLInputElement | null;

    if (questions.some((question) => !getFormValue(formData, question.id))) {
        messages.push('Please make selections for Questions 1-12.');
    }

    requiredApplicationFields.forEach(([name, message]) => {
        if (!getFormValue(formData, name)) {
            messages.push(message);
        }
    });

    if (title && description && title === description) {
        messages.push(
            'Title and Description cannot be the same. Please provide a more detailed description of the course.',
        );
    }

    if (email && emailInput && !emailInput.validity.valid) {
        messages.push('Email Invalid.');
    }

    return messages;
};

const TeachWithUs: React.FC<TeachWithUsProps> = ({ applicationFormModel, currentTab, isSubmitted, tabs }) => {
    const activeTab = tabs.some((tab) => tab.id === currentTab) ? currentTab : 'Introduction';

    return (
        <div className="teach-with-us-legacy">
            <style>{legacyTeachWithUsStyles}</style>
            <div className="ed-frameset">
                <div className="legacy-row">
                    <div className="rowInner">
                        <div className="leftCol">
                            <div className="section">
                                <h1>Teach With Us</h1>
                                <div className="subNav pad5tb">
                                    <ul>
                                        {tabs.map((tab) => {
                                            const tabLink = tabLinkMetadata[tab.id];

                                            return (
                                                <li key={tab.id}>
                                                    <a
                                                        id={tabLink.elementId}
                                                        className={tab.id === activeTab ? 'current' : undefined}
                                                        href={tab.url}
                                                    >
                                                        {tabLink.label}
                                                    </a>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                                <div className="clearfix" />
                                {
                                    {
                                        Introduction: <IntroductionContent />,
                                        Benefits: <BenefitsContent />,
                                        FAQs: <FAQsContent tabs={tabs} />,
                                        CoursesWanted: <CoursesWantedContent />,
                                        Application: (
                                            <ApplicationContent
                                                applicationFormModel={applicationFormModel}
                                                isSubmitted={isSubmitted}
                                            />
                                        ),
                                    }[activeTab]
                                }
                                <br />
                                <div className="clearfix" />
                            </div>
                        </div>
                        <div className="rightCol">
                            {activeTab === 'Application' ? (
                                <aside className="important">
                                    <h1>Important:</h1>
                                    <div className="benefits">
                                        <p className="pad5tb">
                                            Please submit only one application per month and do not enter any more than
                                            one course title or description on that application. If you have ideas for
                                            multiple courses, please complete an application for the one single course
                                            you think will be the most successful in our market.
                                        </p>
                                        <p className="bold">
                                            ( <span className="red">*</span> = Required Fields )
                                        </p>
                                    </div>
                                </aside>
                            ) : (
                                <aside>
                                    <div className="detailsBtnDemo applyBtn">
                                        <a href={getTabUrl(tabs, 'Application')}>
                                            <img src={applyButtonImagePath} alt="Apply to Teach with Us" />
                                        </a>
                                    </div>
                                    <div className="left followUs">
                                        <h1>Benefits of teaching with ed2go include:</h1>
                                        <div className="benefits">
                                            <ul>
                                                {benefits.map((benefit) => (
                                                    <li key={benefit}>{benefit}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </aside>
                            )}
                            <div className="clearfix" />
                        </div>
                        <div className="clearfix" />
                    </div>
                </div>
            </div>
        </div>
    );
};

const IntroductionContent: React.FC = () => (
    <>
        <img src={teachImagePath} className="teachPic" alt="" />
        <p className="intro">
            At ed2go, we help educators and authors develop online courses for one of the largest and fastest-growing
            audiences in the history of education.
        </p>
        <p>
            Knowing that instructors are the most important part of the education equation, the partners in our network
            depend on us to select only the best, brightest, and most motivated candidates for our program. We feel that
            great teaching, like great painting, is an art. Very few people possess the rare and almost magical mix of
            talents required to master the art of education. If you have the patience, the creativity, the compassion,
            and the desire to truly involve and inspire our students, we invite you to apply for a teaching position
            with ed2go.
        </p>
        <h1>The ed2go Network</h1>
        <p>
            If you meet our qualifications, we will help you develop the most highly effective online courses, which are
            then marketed to millions of students through us as well as our entire network of more than 2,100 top
            colleges, universities, and other organizations.
        </p>
        <p>
            Delivering courses online since 1997, we have a deep reservoir of experience that you can rely on to turn
            your dreams of teaching online into reality. We&apos;ll help you diversify and expand your teaching
            opportunities by exposing the course you write to the widest possible audience - all at absolutely no cost
            to you! And you will receive a percentage of all revenues derived from your course.
        </p>
        <p>
            Why limit your efforts to one solitary education provider? We can give you access to an audience large
            enough to turn you into an education industry celebrity! If you&apos;re the kind of teacher that students
            clamor to work with, only ed2go can give you the wide national and international exposure you deserve.
        </p>
    </>
);

const BenefitsContent: React.FC = () => (
    <>
        <p className="intro">
            ed2go has been delivering courses over the Internet since 1997. We have a deep reservoir of experience that
            you can rely on to turn your dreams of teaching online into reality.
        </p>
        <h3>Credibility</h3>
        <p>
            ed2go is the world&apos;s single largest provider of online adult continuing education. We have served over
            a million students and continue to enjoy profitability, leadership within our industry, and double-digit
            enrollment growth. Our distance learning faculty includes some of the most well-known and trusted names in
            online education.
        </p>
        <h3>High Customer Satisfaction</h3>
        <p>
            A genuine ed2go course is more than just a collection of project-oriented lessons, stimulating quizzes, and
            hands-on assignments. Our instructors are famous for their ability to create warm and supportive communities
            of learners. It&apos;s no wonder that many long-lasting friendships have formed in our lively and
            intelligent discussion areas. Our satisfaction and completion rates are among the highest in our industry,
            with more than 95% of our students indicating that they&apos;d like to take another ed2go online course. But
            don&apos;t take our word for it&mdash;see for yourself. Browse our{' '}
            <a href="/search">Online Course Catalog</a> and read the fantastic things students have to say about our
            courses.
        </p>
        <h3>Support</h3>
        <p>
            When you develop a course with ed2go, you will be assisted by editors, copywriters, proofers, illustrators,
            animators, audio engineers, programmers, system administrators, and technical support personnel. You
            won&apos;t need to manage servers, set passwords, help your students with browser and printer problems,
            manage extension requests, grade quizzes, juggle rosters, add and drop students, or even worry about
            attracting students to your course. We have the expertise to manage all of those tasks for you. As a member
            of the ed2go faculty, you will be free to focus on what you do best&mdash;teaching your students. We&apos;ll
            take care of everything else!
        </p>
        <h3>Efficiency</h3>
        <p>
            ed2go builds powerful student-centered learning communities carefully designed to help you facilitate,
            rather than dominate, class discussions. We recognize that time is precious to both you and your students.
            As such, our state-of-the-art Web-based messaging system permits you and your students to interact with one
            another at the times that are most convenient for you. All you need to participate is an Internet connection
            and a Web browser.
        </p>
        <h3>Scalability</h3>
        <p>
            While most online educators are struggling to support classes containing no more than 10 or 15 students,
            ed2go instructors routinely handle dozens or even hundreds of students every month. If you&apos;re a
            talented teacher with knowledge that&apos;s in demand, word will get out, and your classroom could very well
            be flooded with students. But don&apos;t panic! Our system works, and it works well. We promise you that
            your job will get easier as your enrollment levels rise. Our teaching methodology, when coupled with our
            powerful messaging and support systems, will allow you to handle larger number of students in less time. A
            well-designed ed2go course with 100 students should take its instructor no more than 10 hours a week to
            support. That compares quite favorably to the 40 or 50 hours other online educators spend each week to
            support fewer than 15 students.
        </p>
        <h3>Marketing</h3>
        <p>
            If you join our faculty, the colleges, universities, adult schools, and other training organizations that
            make up the ed2go network will throw their reputations and marketing muscles behind your course.
            Descriptions of your course will literally blanket the nation as many of the more than 2,100 schools in our
            network begin to market your course toward the communities they serve. These schools use direct mail, press
            releases, advertising, and other marketing tools to sell ed2go courses.
        </p>
        <h3>Compensation</h3>
        <p>
            ed2go was founded by a teacher with many years of primary, secondary, and post-secondary classroom
            experience. We firmly believe that students learn best under the patient tutelage of a talented teacher.
            Because we owe so much of our success to the talent and dedication of our instructors, we have always
            provided our teachers with the most generous compensation plan in the industry. We view our relationship
            with you as a partnership, and feel that you have as much at stake in the success of your course as we do.
            As such, we will not place any caps on the income you can receive from your course. If you&apos;re willing
            and able to make a difference in our students&apos; lives, we will do all that we can to provide you with
            the financial and professional rewards that you deserve.
        </p>
    </>
);

const FAQsContent: React.FC<{ tabs: TeachWithUsTab[] }> = ({ tabs }) => (
    <>
        <p className="intro">
            Here are answers to some of the questions potential instructors frequently ask about teaching with ed2go.
        </p>
        <h3>Do I have to pay anything in order to participate?</h3>
        <p>
            Absolutely not! If you are selected to join the ed2go faculty, we will develop your course at our expense.
        </p>
        <h3>How many schools do you work with?</h3>
        <p>
            We provide Online Courses to a network of over 2,100 top colleges, universities, and other organizations -
            from the State Universities of New York to the California State University system, and everywhere in
            between. Find <a href="/online-schools/">participating partners</a> in your area.
        </p>
        <h3>What type of student will be taking my courses?</h3>
        <p>
            The colleges, universities, and other organizations in our network will market your courses directly to
            working adults in the community through their community education, community services, adult education,
            workforce development, contract training, and/or extension departments. Your course will be credit-free,
            which means that enrollment will be open to anyone. Other than the fact that your course will be marketed
            primarily to adults in their 20s, 30s, 40s, 50s, 60s, and beyond, your audience will not be limited to
            students of any one occupation, nationality, ethnicity, gender, or any other factor.
        </p>
        <h3>How will I know how many students are in my class?</h3>
        <p>
            When your course begins, you will be provided with access to a real-time course statistics page showing the
            number of students who have enrolled in each of your course sections.
        </p>
        <h3>How many hours can I expect students to spend on each lesson?</h3>
        <p>Each lesson should be designed to take no more than two hours of the student&apos;s time to explore.</p>
        <h3>
            How much time will I spend answering student questions, providing feedback, checking links, correcting
            errors, and updating my course materials?
        </h3>
        <p>
            We require you to commit at least 10 hours per week to your online classroom. Of course, you are always
            welcome to spend more time improving your course and keeping your students satisfied. Think of your course
            as if it were a business, and think of your students as your customers. We have found a direct correlation
            between the amount of time an instructor spends caring for students and the level of student satisfaction
            with the course. This satisfaction usually translates into good word of mouth and steady enrollments.
        </p>
        <h3>
            What happens if students forget their passwords or have other technical difficulties? Will I be bombarded
            with questions that are unrelated to my course material?
        </h3>
        <p>
            You are only required to answer questions related to your course material. We will provide you with support
            staff to help your students sort out any other issues that arise.
        </p>
        <h3>Will I need to evaluate my students&apos; quizzes and assignments?</h3>
        <p>
            Not unless you want to. All of our quizzes are fully automated, and we will teach you how to create
            assignments that can be self-evaluated by your students.
        </p>
        <h3>What sort of record-keeping is required? Do I need to take roll and keep a gradebook?</h3>
        <p>
            All of our record-keeping is automated. The students add themselves to your rosters automatically, and
            qualified college representatives will grant your students access to your online classroom. All quiz and
            final exam scores are logged in a student database. Both the student and his or her sponsoring school will
            have instant access to online progress reports and completion letters.
        </p>
        <h3>How much time will it take me to develop a course for you?</h3>
        <p>
            Most of our instructors require three to six months of development time before their course is considered
            complete.
        </p>
        <h3>How often will my course be offered to students?</h3>
        <p>
            A new session of your course will begin on the second or third Wednesday of each month. This means that your
            course will be offered 12 times each year.
        </p>
        <h3>Must I teach every month? I like to take off during certain times of the year.</h3>
        <p>
            Your classroom is entirely Web-based, which means that you can access your discussion areas from almost
            anywhere in the world. If you can get on the Internet, you can facilitate your class discussions. Most of
            our instructors have obtained laptops so that they can log on and manage their discussion areas even when
            traveling. If you will be without Internet access for more than one week in any given year, you will either
            need to hire a substitute teacher to monitor your discussion areas, or you will need to reconsider your
            ability to facilitate online instruction.
        </p>
        <h3>
            Do the students have an opportunity to provide me with any constructive feedback on my course or
            instructional technique?
        </h3>
        <p>
            Each of your students will be invited to submit an evaluation of your course. These evaluations will be made
            available to you the instant that they are received from the student.
        </p>
        <h3>How much money will I make?</h3>
        <p>
            That depends on how many courses you decide to teach for us and how many students enroll in each course
            every month. Our best advice: don&apos;t quit your day job! Teach online because you <strong>want</strong>{' '}
            to teach online, not because you <strong>have</strong> to do so. Look to your online courses to provide you
            with a convenient way to supplement your regular income while working part-time from the comfort of home. If
            you&apos;re a writer (or just aspire to be one), there are other benefits: teaching online can provide you
            with a reliable source of extra income while also giving you opportunities to interact directly with your
            readers, to build an online following, and to solicit feedback and inspiration for additional works.
        </p>
        <h3>How often do I get paid?</h3>
        <p>Royalty checks are mailed once monthly, no later than 30 days after the end of each course section.</p>
        <h3>May I require the purchase of a textbook as a prerequisite for enrollment in my course?</h3>
        <p>
            No. Although we encourage you to recommend books (including your own) to students, we will not permit you to
            require the purchase of any book. Online students are extremely sensitive to price and convenience. Our
            experience has shown that a textbook requirement is costly, inconvenient, and detrimental to enrollments.
            Instead of requiring your students to buy a book, try developing a course that is so complete,
            well-researched, and well-written that your students will not require a textbook. When your course is fully
            written, your students should be able to print your lessons to use as a comprehensive reference guide to the
            subject matter you teach.
        </p>
        <h3>Who teaches for you?</h3>
        <p>
            We&apos;ve assembled a teaching staff that is second to none, including the likes of best-selling authors
            Alan Simpson, Sherry London, Eva Shaw, and many more.
        </p>
        <h3>What do other instructors say about you?</h3>
        <p>Here are some actual quotes from members of our teaching staff:</p>
        <p>
            &quot;Working with ed2go has been a fun ride so far, and an increasingly lucrative one at that. I spent a
            couple of months developing my courses and now suddenly I have several hundred students from all over the
            U.S. and Canada! The folks at ed2go have responded rapidly when I needed changes made to my materials and
            have (gently) nudged me to provide fixes or changes necessary. I heartily recommend doing a course or three
            with ed2go.&quot;
        </p>
        <p style={{ textAlign: 'right' }}>
            -Scott Jernigan
            <br />
            PC Troubleshooting, A+ Certification
        </p>
        <br />
        <p>
            &quot;I have been working with ed2go since their inception. Getting the lessons written was the hard part,
            of course. After that, things are pretty simple. To keep my class up-to-date, I have to periodically update
            the material. I also spend between 10 and 45 minutes a day answering questions from students. The
            enrollments in my classes keep increasing, and I look forward to consistently receiving a check in the mail
            between the third and fourth weeks of every month. The founder is one of the nicest, most honest people I
            know. Any reservations I may have had at first about ed2go were put to rest because of my respect for the
            founder of ed2go.&quot;
        </p>
        <p style={{ textAlign: 'right' }}>
            -Kathy Van Pelt
            <br />
            PowerPoint, Keyboarding
        </p>
        <br />
        <p>
            &quot;I highly recommend the people of ed2go. I&apos;m delighted with both the instructional and the
            financial sides of my partnership with ed2go.&quot;
        </p>
        <p style={{ textAlign: 'right' }}>
            -Eva Shaw
            <br />
            Travel Writing, The Craft of Magazine Writing, Writerrific!
        </p>
        <h3>
            What does <em>ed2go</em> mean, anyway?
        </h3>
        <p>
            The legal name of our company is <strong>Education To Go</strong> and we are part of Cengage Learning. The
            <strong> ed2go</strong> moniker is just an abbreviated form of that name.
        </p>
        <h3>What courses are you already offering?</h3>
        <p>
            Check our <a href="/search">Online Course Catalog</a> to see the titles we are offering at this time.
        </p>
        <h3>What do I do next?</h3>
        <p>
            Check out the list of <a href={getTabUrl(tabs, 'CoursesWanted')}>Courses Wanted</a> to see some of the
            teaching opportunities available.
        </p>
    </>
);

const CoursesWantedContent: React.FC = () => (
    <>
        <p className="intro">
            Our network of partners provides a ready market for noncredit continuing education courses. Below, please
            find a list of the topics for which we are presently accepting applications. Please note that you should
            have paid professional and teaching experience that directly relates to the application topic.
        </p>
        <div className="cms" />
    </>
);

const ApplicationContent: React.FC<{
    applicationFormModel: TeachWithUsApplicationFormModel;
    isSubmitted: boolean;
}> = ({ applicationFormModel, isSubmitted }) => {
    if (isSubmitted) {
        return (
            <>
                <p className="intro" style={{ borderBottom: 0, paddingBottom: 0 }}>
                    Thank You
                </p>
                <p>
                    Thank you for submitting your application to teach with us. Due to the volume of applications
                    received, we are only able to contact those approved. Approved applicants will be contacted via
                    email within 30-days of submission.
                </p>
            </>
        );
    }

    return <TeachWithUsApplicationForm applicationFormModel={applicationFormModel} />;
};

const TeachWithUsApplicationForm: React.FC<{ applicationFormModel: TeachWithUsApplicationFormModel }> = ({
    applicationFormModel,
}) => {
    const [validated, setValidated] = React.useState(false);
    const [validationMessages, setValidationMessages] = React.useState<string[]>([]);

    return (
        <>
            <h3>Apply To Teach With Us</h3>
            <p>
                If you&apos;re interested in teaching with Education To Go, we ask that you please complete the brief
                application form below.
            </p>
            <p id="instruct">
                We want you to succeed! Please pay very close attention to the first twelve questions below. If you can
                honestly answer yes to each and every one of these questions, we&apos;d be very interested in learning
                more about you!
            </p>
            <Form
                action={applicationFormModel.submitPath}
                method="post"
                noValidate
                validated={validated}
                onSubmit={(event) => {
                    const form = event.currentTarget;

                    Array.from(form.elements).forEach((element) => {
                        const input =
                            (element.nodeName === 'INPUT' && (element as HTMLInputElement)) ||
                            (element.nodeName === 'TEXTAREA' && (element as HTMLTextAreaElement));
                        if (input && input.type !== 'hidden') {
                            input.value = input.value.trim();
                        }
                    });

                    const formData = new FormData(form);
                    const nextValidationMessages = getTeachWithUsApplicationValidationMessages(form, formData);

                    if (!form.checkValidity() || nextValidationMessages.length > 0) {
                        event.preventDefault();
                        event.stopPropagation();
                        setValidationMessages(nextValidationMessages);
                        setValidated(true);
                        form.querySelector<HTMLElement>(':invalid')?.focus();
                    } else {
                        setValidationMessages([]);
                    }
                }}
            >
                {validationMessages.length > 0 && (
                    <ul className="red ital validation-summary">
                        {validationMessages.map((message) => (
                            <li key={message}>{message}</li>
                        ))}
                    </ul>
                )}
                <h2>General Information</h2>
                <ol className="faqs" id="questionList">
                    {questions.map((question) => (
                        <li key={question.id}>
                            <div className="question">
                                {question.text} <span className="red">*</span>
                            </div>
                            <div className="answer">
                                <Form.Check
                                    inline
                                    id={`${question.id}-yes`}
                                    label="Yes"
                                    name={question.id}
                                    required
                                    type="radio"
                                    value="Yes"
                                />
                                <Form.Check
                                    inline
                                    id={`${question.id}-no`}
                                    label="No"
                                    name={question.id}
                                    required
                                    type="radio"
                                    value="No"
                                />
                                <p className="note">{question.note}</p>
                            </div>
                        </li>
                    ))}
                </ol>
                <h2>About Your Course:</h2>
                <ol className="faqs">
                    <li>
                        <div className="question">
                            Title <span className="red">*</span>
                            <br />
                            <span className="ed-text-default answer">
                                Type a brief title for the course you want to write. Two to five words is ideal; please{' '}
                                <b>do not submit</b> a title with more than eight words:
                            </span>
                        </div>
                        <div className="answer">
                            <Form.Control className="formField" name="course_title" pattern=".*\S+.*" required />
                        </div>
                    </li>
                    <li>
                        <div className="question">
                            Description <span className="red">*</span>
                            <br />
                            <span className="ed-text-default answer">
                                Briefly describe the course you want to write:
                            </span>
                        </div>
                        <div className="answer">
                            <Form.Control
                                as="textarea"
                                className="formField"
                                cols={75}
                                name="course_description"
                                required
                                rows={3}
                            />
                        </div>
                    </li>
                    <li>
                        <div className="question">
                            Target Audience <span className="red">*</span>
                            <br />
                            <span className="ed-text-default answer">
                                We specialize in credit-free courses for adults aged between 24 and 75. Please describe
                                the segment of our market to which your course is targeted. (Three examples:{' '}
                                <i>Women over 50</i>, <i>Young adults in their mid twenties</i>,{' '}
                                <i>Small business owners of any age</i>, etc.)
                            </span>
                        </div>
                        <div className="answer">
                            <Form.Control
                                as="textarea"
                                className="formField"
                                cols={75}
                                name="target_audience"
                                required
                                rows={3}
                            />
                        </div>
                    </li>
                    <li>
                        <div className="question">
                            Justification
                            <br />
                            <span className="ed-text-default answer">
                                Why should Education To Go offer your course? Tell us how you feel Education To Go would
                                benefit by adding your new course to our current catalog of offerings.
                            </span>
                        </div>
                        <div className="answer">
                            <Form.Control as="textarea" className="formField" cols={75} name="justification" rows={3} />
                        </div>
                    </li>
                </ol>
                <h2>About You:</h2>
                <ol className="faqs">
                    <li>
                        <div className="question">
                            Your e-mail Address: <span className="red">*</span>
                        </div>
                        <div className="answer">
                            <Form.Control className="formField" name="email" required type="email" />
                        </div>
                    </li>
                    <li>
                        <div className="question">
                            Your First Name: <span className="red">*</span>
                        </div>
                        <div className="answer">
                            <Form.Control className="formField" name="first_name" pattern=".*\S+.*" required />
                        </div>
                    </li>
                    <li>
                        <div className="question">
                            Your Last Name: <span className="red">*</span>
                        </div>
                        <div className="answer">
                            <Form.Control className="formField" name="last_name" pattern=".*\S+.*" required />
                        </div>
                    </li>
                    <li>
                        <div className="question">
                            Day Phone: <span className="red">*</span>
                        </div>
                        <div className="answer">
                            <Form.Control className="formField" name="phone" pattern=".*\S+.*" required type="tel" />
                        </div>
                    </li>
                    <li>
                        <div className="question">Evening Phone:</div>
                        <div className="answer">
                            <Form.Control className="formField" name="evening_phone" type="tel" />
                        </div>
                    </li>
                    <li>
                        <div className="question">Street Address (Line 1):</div>
                        <div className="answer">
                            <Form.Control className="formField" name="address_1" />
                        </div>
                    </li>
                    <li>
                        <div className="question">Street Address (Line 2):</div>
                        <div className="answer">
                            <Form.Control className="formField" name="address_2" />
                        </div>
                    </li>
                    <li>
                        <div className="question">City/State/Zip:</div>
                        <div className="answer">
                            <Form.Control className="formField" name="city_state_zip" />
                        </div>
                    </li>
                    <li>
                        <div className="question">Country (if not USA):</div>
                        <div className="answer">
                            <Form.Control className="formField" name="country" />
                        </div>
                    </li>
                    <li>
                        <div className="question">Your Highest Level of Education:</div>
                        <div className="answer">
                            <Form.Control as="select" className="formField" name="education">
                                <option value="No Response">Select one...</option>
                                <option value="Bachelor Degree">Bachelor&apos;s Degree</option>
                                <option value="Master Degree">Master&apos;s Degree</option>
                                <option value="Doctorate">Doctorate</option>
                                <option value="Community College">Community College</option>
                                <option value="High School">High School</option>
                            </Form.Control>
                        </div>
                    </li>
                    <li>
                        <div className="question">
                            Major
                            <br />
                            <span className="ed-text-default answer">
                                If you hold a Bachelor&apos;s degree, Master&apos;s degree, or Doctorate, please specify
                                the major field of study for each degree earned:
                            </span>
                        </div>
                        <div className="answer">
                            <Form.Control as="textarea" className="formField" cols={75} name="degrees" rows={3} />
                        </div>
                    </li>
                    <li>
                        <div className="question">
                            Professional Experience
                            <br />
                            <span className="ed-text-default answer">
                                Briefly describe the duration and extent of your paid experience with the subject matter
                                you wish to teach.
                            </span>
                        </div>
                        <div className="answer">
                            <Form.Control
                                as="textarea"
                                className="formField"
                                cols={75}
                                name="work_experience"
                                rows={3}
                            />
                        </div>
                    </li>
                    <li>
                        <div className="question">
                            Teaching Experience
                            <br />
                            <span className="ed-text-default answer">
                                Briefly describe the duration and extent of your teaching experience.
                            </span>
                        </div>
                        <div className="answer">
                            <Form.Control
                                as="textarea"
                                className="formField"
                                cols={75}
                                name="teaching_experience"
                                rows={3}
                            />
                        </div>
                    </li>
                    <li>
                        <div className="question">
                            Writing Experience
                            <br />
                            <span className="ed-text-default answer">
                                Briefly describe your writing background. Tell us about any published articles, books,
                                or other written material you have produced.
                            </span>
                        </div>
                        <div className="answer">
                            <Form.Control
                                as="textarea"
                                className="formField"
                                cols={75}
                                name="writing_experience"
                                rows={3}
                            />
                        </div>
                    </li>
                </ol>
                <p className="submit">
                    <button className="submitButton" type="submit">
                        Submit
                    </button>
                </p>
            </Form>
        </>
    );
};

export { TeachWithUs, TeachWithUsProps };
